export const dataRaw = {
  "ASD-GSE-01CR01-PAC002": [
    {
      1: "4",
      Year: "2015",
      0.2: "0",
      0.3: "1",
      0.4: "2",
      0.6: "1",
      0.8: "2.00",
    },
    {
      1: "5",
      Year: "2016",
      0.2: "1",
      0.3: "2",
      0.4: "2",
      0.6: "1",
      0.8: "2",
    },
    {
      1: "5",
      Year: "2017",
      0.2: "1",
      0.3: "2",
      0.4: "2",
      0.6: "2",
      0.8: "2",
    },
    {
      1: "4",
      Year: "2018",
      0.2: "0",
      0.3: "1",
      0.4: "2",
      0.6: "1",
      0.8: "2",
    },
    {
      1: "5",
      Year: "2019",
      0.2: "1",
      0.3: "2",
      0.4: "2",
      0.6: "2",
      0.8: "2",
    },
    {
      1: "5",
      Year: "2020",
      0.2: "1",
      0.3: "2",
      0.4: "2",
      0.6: "1",
      0.8: "2",
    },
    {
      1: "4",
      Year: "2021",
      0.2: "1",
      0.3: "2",
      0.4: "2",
      0.6: "2",
      0.8: "2",
    },
    {
      1: "5",
      Year: "2022",
      0.2: "0",
      0.3: "1",
      0.4: "2",
      0.6: "1",
      0.8: "2",
    },
    {
      1: "5",
      Year: "2023",
      0.2: "1",
      0.3: "2",
      0.4: "2",
      0.6: "2",
      0.8: "2",
    },
    {
      1: "4",
      Year: "2024",
      0.2: "1",
      0.3: "2",
      0.4: "2",
      0.6: "1",
      0.8: "2",
    },
    {
      1: "6",
      Year: "2025",
      0.2: "1",
      0.3: "2",
      0.4: "2",
      0.6: "2",
      0.8: "3",
    },
    {
      1: "6",
      Year: "2026",
      0.2: "1",
      0.3: "2",
      0.4: "3",
      0.6: "2",
      0.8: "3",
    },
    {
      1: "7",
      Year: "2027",
      0.2: "1",
      0.3: "3",
      0.4: "3",
      0.6: "2",
      0.8: "3",
    },
    {
      1: "9",
      Year: "2028",
      0.2: "1",
      0.3: "3",
      0.4: "4",
      0.6: "3",
      0.8: "4",
    },
    {
      1: "11",
      Year: "2029",
      0.2: "2",
      0.3: "4",
      0.4: "5",
      0.6: "4",
      0.8: "5",
    },
    {
      1: "22",
      Year: "2030",
      0.2: "2",
      0.3: "5",
      0.4: "5",
      0.6: "4",
      0.8: "6",
    },
  ],
  "ASD-GSE-03CR02-PAC003": [
    {
      1: "0",
      Year: "2015",
      0.2: "0",
      0.3: "1",
      0.4: "1",
      0.6: "1",
      0.7: "0.00",
      0.8: "2",
      "Grand Total": "5",
    },
    {
      1: "1",
      Year: "2016",
      0.2: "0",
      0.3: "2",
      0.4: "1",
      0.6: "1",
      0.7: "0",
      0.8: "2",
      "Grand Total": "7",
    },
    {
      1: "1",
      Year: "2017",
      0.2: "1",
      0.3: "1",
      0.4: "1",
      0.6: "2",
      0.7: "1",
      0.8: "2",
      "Grand Total": "9",
    },
    {
      1: "1",
      Year: "2018",
      0.2: "0",
      0.3: "2",
      0.4: "1",
      0.6: "1",
      0.7: "0",
      0.8: "2",
      "Grand Total": "7",
    },
    {
      1: "0",
      Year: "2019",
      0.2: "1",
      0.3: "2",
      0.4: "1",
      0.6: "2",
      0.7: "1",
      0.8: "2",
      "Grand Total": "9",
    },
    {
      1: "1",
      Year: "2020",
      0.2: "0",
      0.3: "1",
      0.4: "2",
      0.6: "1",
      0.7: "0",
      0.8: "2",
      "Grand Total": "7",
    },
    {
      1: "1",
      Year: "2021",
      0.2: "1",
      0.3: "2",
      0.4: "1",
      0.6: "2",
      0.7: "1",
      0.8: "3",
      "Grand Total": "11",
    },
    {
      1: "1",
      Year: "2022",
      0.2: "0",
      0.3: "2",
      0.4: "1",
      0.6: "1",
      0.7: "0",
      0.8: "2",
      "Grand Total": "7",
    },
    {
      1: "0",
      Year: "2023",
      0.2: "1",
      0.3: "1",
      0.4: "1",
      0.6: "2",
      0.7: "1",
      0.8: "2",
      "Grand Total": "8",
    },
    {
      1: "1",
      Year: "2024",
      0.2: "0",
      0.3: "2",
      0.4: "1",
      0.6: "1",
      0.7: "0",
      0.8: "2",
      "Grand Total": "7",
    },
    {
      1: "1",
      Year: "2025",
      0.2: "1",
      0.3: "2",
      0.4: "2",
      0.6: "2",
      0.7: "1",
      0.8: "2",
      "Grand Total": "11",
    },
    {
      1: "1",
      Year: "2026",
      0.2: "0",
      0.3: "2",
      0.4: "1",
      0.6: "2",
      0.7: "0",
      0.8: "3",
      "Grand Total": "9",
    },
    {
      1: "1",
      Year: "2027",
      0.2: "1",
      0.3: "3",
      0.4: "2",
      0.6: "2",
      0.7: "1",
      0.8: "4",
      "Grand Total": "14",
    },
    {
      1: "2",
      Year: "2028",
      0.2: "1",
      0.3: "3",
      0.4: "3",
      0.6: "3",
      0.7: "1",
      0.8: "4",
      "Grand Total": "17",
    },
    {
      1: "1",
      Year: "2029",
      0.2: "1",
      0.3: "4",
      0.4: "2",
      0.6: "4",
      0.7: "1",
      0.8: "5",
      "Grand Total": "18",
    },
  ],
  "LSD-MWB-01WK13-PAC004": [
    {
      Year: "2015",
      0.3: "0",
      0.4: "0",
      "Grand Total": "0",
    },
    {
      Year: "2016",
      0.3: "0",
      0.4: "1",
      "Grand Total": "1",
    },
    {
      Year: "2017",
      0.3: "0",
      0.4: "1",
      "Grand Total": "1",
    },
    {
      Year: "2018",
      0.3: "1",
      0.4: "0",
      "Grand Total": "1",
    },
    {
      Year: "2019",
      0.3: "0",
      0.4: "1",
      "Grand Total": "1",
    },
    {
      Year: "2020",
      0.3: "0",
      0.4: "1",
      "Grand Total": "1",
    },
    {
      Year: "2021",
      0.3: "0",
      0.4: "1",
      "Grand Total": "1",
    },
    {
      Year: "2022",
      0.3: "1",
      0.4: "0",
      "Grand Total": "1",
    },
    {
      Year: "2023",
      0.3: "0",
      0.4: "1",
      "Grand Total": "1",
    },
    {
      Year: "2024",
      0.3: "0",
      0.4: "1",
      "Grand Total": "1",
    },
    {
      Year: "2025",
      0.3: "0",
      0.4: "0",
      "Grand Total": "0",
    },
    {
      Year: "2026",
      0.3: "1",
      0.4: "1",
      "Grand Total": "2",
    },
    {
      Year: "2027",
      0.3: "0",
      0.4: "2",
      "Grand Total": "2",
    },
    {
      Year: "2028",
      0.3: "1",
      0.4: "1",
      "Grand Total": "2",
    },
    {
      Year: "2029",
      0.3: "0",
      0.4: "2",
      "Grand Total": "2",
    },
  ],
};
